import { render, staticRenderFns } from "./ifmActivity.vue?vue&type=template&id=4901fd2b&scoped=true"
import script from "./ifmActivity.vue?vue&type=script&lang=js"
export * from "./ifmActivity.vue?vue&type=script&lang=js"
import style0 from "./ifmActivity.vue?vue&type=style&index=0&id=4901fd2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901fd2b",
  null
  
)

export default component.exports